export { default } from './BonusProgram';
